import { createSelector } from 'reselect'

export const encounterSelector = (state) => state.fhir

export const allEncountersLoading = createSelector(
  encounterSelector,
  ({ encounterReadLoading }) => encounterReadLoading
)

export const allEncounters = createSelector(
  encounterSelector,
  ({ encounter }) => encounter
)
